module.exports = __webpack_public_path__ + "static/media/5-8.af993b57.mp3";